<template>
  <!-- Start Preferences -->
  <div class="options">
    <p class="text-center font-weight-bold my-3">
      {{ $t("text.compose_your_meal_deal") }}
    </p>
    <el-collapse v-model="activeNames">
      <el-collapse-item v-for="(section, sectionIndex) in sections" :key="sectionIndex" :name="section.id">
        <template slot="title">
          <div class="media w-100">
            <div class="media-body text-sm">
              <span class="font-weight-bolder option-name mr-2">{{ section.name }}</span> <span v-if="isDeliverect" class="option-max-min">{{ section.max_quantity != 1 ? `Min
                              ${section.minimum_quantity}, Max ${section.max_quantity == 0 ? '*' : section.max_quantity}` : ''
              }}</span>
            </div>
            <div class="d-flex align-items-center">
              <span v-if="getSectionTotal(section, orderType) > 0" class="text-success text-sm mr-2">{{
                getSectionTotal(section, orderType) |
                currency }}</span>
              <span v-if="section.is_required" class="text-danger text-xl mr-2 mt-2">*</span>
            </div>
          </div>
        </template>
        <div v-if="section.type == 'RADIO'">
          <el-radio-group v-model="section.selected" class="d-flex flex-column">
            <el-radio v-for="subProduct in section.subProducts" :key="subProduct.id"
              class="media text-black w-100 el-reverse-radio" :label="subProduct.id"
              @change="handleSelectedValue({ section, subProduct, isSingle: true })">

              <div class="media-body d-flex flex-column">
                <span>{{ subProduct.name }}</span>
                <div v-if="subProduct.hasOptions && subProduct.options"
                  v-html="getFormattedSelectedItems(subProduct.options)"></div>
              </div>
              <div class="price text-center">
                {{ getMenuItemPrice(subProduct, orderType) | currency }}
              </div>
            </el-radio>
          </el-radio-group>
        </div>
        <div v-else>
          <multi-check-button v-for="(item, itemIndex) in section.subProducts" :key="itemIndex" :item="item"
            :section="section" @onSelectedValue="handleSelectedValue"
            :clone-sections="cloneSections"></multi-check-button>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import {
  checkMaxQuantitySelectedByOption,
  getSectionTotal,
  formatSelectedItems,
  getMenuItemPrice,
  clone,
} from "@/utilities/helper";
import MultiCheckButton from './MultiCheckButton'

export default {
  components: {
    MultiCheckButton
  },
  props: {
    sections: Array,
    orderType: {
      type: Number,
      required: true
    },
    isDeliverect:{
      type: Boolean,
      default: true
    }
  },
  computed: {
    checkIfValueSelected() {
      return (section, value_id) => {
        if (!section.selected_items) return 0;
        if (!Array.isArray(section.selected_items)) return 0;
        const item = section.selected_items.find((x) => x.id == value_id);
        return item ? item.quantity : 0;
      };
    },
    getFormattedSelectedItems() {
      return (options) => {
        return formatSelectedItems(options);
      };
    },
  },
  data() {
    return {
      getMenuItemPrice,
      getSectionTotal,
      activeNames: [],
      cloneSections: [],
    };
  },
  methods: {
    //--- DONE
    handleSelectedValue(data) {
      if (!data.section.selected) {
        data.section.selected = [];
      }
      if (!data.section.selected_items) {
        data.section.selected_items = [];
      }
      if (data.isSingle) {
        data.section.selected_items = [];
        let otherValues = data.section.subProducts.filter(v => v.id != data.section.selected)
        otherValues.forEach(value => {
          if (value.options.length) {
            value.options.forEach(option => {
              option.selected = null
              option.selected_items = []
            })
          }
        });
      }

      if (
        data.subProduct?.hasOptions &&
        data.subProduct?.options &&
        !data.section?.selected_items?.length
      ) {
        this.$parent.$parent.$emit("onShowSubProductOptions", data);
      } else {
        this.addSelectedSubProduct(data);
      }
    },
    //--- DONE
    addSelectedSubProduct(data) {
      if (data.isSingle) {
        data.section.selected_items = [
          {
            id: data.subProduct.id,
            name: data.subProduct.name,
            price: getMenuItemPrice(data.subProduct, this.orderType),
            quantity: 1,
          },
        ];

        return;
      }

      // check if the max quantity is eached by value , and by option
      if (checkMaxQuantitySelectedByOption(data.section, data.subProduct)) {
        return false;
      }
      data.section.selected.push(data.subProduct.id);

      let itemFound = data.section.selected_items.find(
        (x) => x.id == data.subProduct.id
      );

      if (itemFound) {
        itemFound.quantity++;
      } else {
        data.section.selected_items.push({
          id: data.subProduct.id,
          name: data.subProduct.name,
          price: getMenuItemPrice(data.subProduct, this.orderType),
          quantity: 1,
        });
      }
    },
  },
  created() {
    this.$root.$on("PUSH_MEAL_DEAL_OPTIONS", (data) => {
      this.addSelectedSubProduct(data);
    });
    this.cloneSections = clone(this.sections);
  },
  beforeDestroy() {
    this.$root.$off("PUSH_MEAL_DEAL_OPTIONS");
  },
};
</script>
